import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Animated from '../Animated';
import theme from '../../actions/theme';
import { textContainer } from '../../styles';
import BigList from '../BigList';

const getImage = (folder, filename, r) => {
  return [
    {
      srcSet: require(`../../assets/${folder}/${filename}-thumb-${r}.jpg`),
      media: '(max-width: 100px)',
    },
    {
      srcSet: require(`../../assets/${folder}/${filename}-sm-${r}.jpg`),
      media: '(max-width: 720px)',
    },
    {
      srcSet: require(`../../assets/${folder}/${filename}-${r}.jpg`),
    },
  ];
};

class NFTs extends Component {
  constructor(props) {
    super(props);
    this.state = { set1: [], set2: [] };
  }

  componentWillMount() {
    this.props.loadTheme();
  }

  componentWillReceiveProps(nextProps) {
    const randomSolastalgiaImage = getImage('solastalgia', 'solastalgia', 5);
    const randomAGSMUImage = getImage('agsmu', 'agsmu', 1);
    const randomBlomImage = getImage(
      'blom',
      'blom-a-generative-art-series-by-lucastswick',
      941,
    );
    const randomBlomPysankyImage = getImage(
      'blom-pysanky',
      'blom-pysanky',
      134,
    );
    const randomFormAndDecayImage = getImage(
      'form-and-decay',
      'form-and-decay',
      4,
    );
    this.setState({
      items: {
        solastalgia: {
          title: 'Solastalgia',
          uid: 'solastalgia',
          slug: 'solastalgia',
          link: 'https://foundation.app/collection/solastalgia?sort=newest',
          excerpt:
            'Solastalgia is the cousin to nostalgia. Whereas nostalgia is a yearning for something once experienced, solastalgia is more nuanced; the feeling of being in a place while simultaneously holding the understanding that the enjoyment may never be felt again, as that place is in an evolving state of entropy due to climate disaster.',
          cta: 'See it on Foundation',
          // colorTheme: { base: '#121212', hilite: '#df0000' },
          headerImage: randomSolastalgiaImage,
          images: [randomSolastalgiaImage],
        },
        AGMSU: {
          title: 'A Great Space Mind Unfolding',
          uid: 'agsmu',
          slug: 'agsmu',
          link: 'https://www.fxhash.xyz/generative/slug/a-great-space-mind-unfolding',
          excerpt:
            'AGSMU is a piece created for day 3 of genuary, prompt "Glitch". 10,000 shapes move in wave-like motion, intersecting and leaving trails, to produce a relaxing but dynamic motion piece.',
          cta: 'See it on fx(hash)',
          // colorTheme: { base: '#121212', hilite: '#df0000' },
          headerImage: randomAGSMUImage,
          images: [randomAGSMUImage],
        },
        blom: {
          title: 'Blóm',
          uid: 'blom',
          slug: 'blom',
          link: 'https://opensea.io/collection/blom-by-lucastswick?search[sortAscending]=false',
          excerpt: 'Over 1000 Blóms were minted with Gen.art.',
          cta: 'Explore the collection on OpenSea',
          // colorTheme: { base: '#121212', hilite: '#df0000' },
          headerImage: randomBlomImage,
          images: [randomBlomImage],
        },
        blomPysanky: {
          title: 'Blóm Pysanky',
          uid: 'blom',
          slug: 'blom',
          excerpt: 'I airdropped Easter Eggs to Blóm holders.',
          link: 'https://www.generativepysanky.com/',
          cta: 'Check them out',
          // colorTheme: { base: '#121212', hilite: '#df0000' },
          headerImage: randomBlomPysankyImage,
          images: [randomBlomPysankyImage],
        },
        formAndDecay: {
          title: 'Form and Decay',
          uid: 'form-and-decay',
          slug: 'form-and-decay',
          link: 'https://opensea.io/collection/lucastswick-form-decay',
          excerpt: 'My first NFT collection ever!',
          cta: 'View on OpenSea',
          // colorTheme: { base: '#121212', hilite: '#df0000' },
          headerImage: randomFormAndDecayImage,
          images: [randomFormAndDecayImage],
        },
      },
    });
  }

  render() {
    const { items } = this.state;
    if (!items) return null;

    const { theme } = this.props;

    return (
      <Fragment>
        <div {...textContainer}>
          <Animated as="h1">NFT Collections</Animated>
        </div>

        <BigList items={items} theme={theme} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  theme: state.theme,
});
const mapDispatchToProps = (dispatch) => ({
  loadTheme: bindActionCreators(theme.fetch, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(NFTs);



// WEBPACK FOOTER //
// ./src/components/NFTs/index.js